import UltMeta, { Meta } from "./UltMeta/index";
//交易管理--商品管理

/**
 * 商品支付方式
 */
class TradeProductPayType extends UltMeta {
    ONLINE = new Meta(1, "线上支付");
    OFFLINE = new Meta(2, "线下支付");
    ONLINE_AND_OFFLINE = new Meta(3, "线上支付、线下支付");
}

export const TRADE_PRODUCT_PAY_TYPE = new TradeProductPayType();